module.exports = __webpack_public_path__ + "static/img/3.7009f27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/3.png
// module id = i+ai
// module chunks = 0